import { createPortal } from 'react-dom';
import { useLoader } from './useLoader';

export const LoaderRoot = () => {
  const { isLoading, message } = useLoader();

  if (!isLoading) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[70] flex flex-col items-center justify-center bg-black/60 backdrop-blur-sm transition-opacity duration-200"
      role="alert"
      aria-busy="true"
      aria-label={message || 'Loading'}
    >
      {/* Custom CSS Spinner (No external libs) */}
      <div className="relative">
        <div className="w-16 h-16 border-4 border-white/30 border-t-white rounded-full animate-spin"></div>
        {/* Optional inner circle for style */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-8 h-8 border-4 border-white/50 border-b-transparent rounded-full animate-spin"></div>
        </div>
      </div>

      {message && <p className="mt-4 text-white font-medium text-lg animate-pulse">{message}</p>}
    </div>,
    document.body
  );
};
